// extracted by mini-css-extract-plugin
module.exports = {"auto":"auto-uXr_J4Ji"};